import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router';
import {nextTick} from 'vue';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/HomeViewV3.vue'),
    },
    {
        path: '/t',
        name: 'THome',
        component: () => import('@/views/v3t/HomeViewV3T.vue'),
    },
    {
        path: '/about',
        name: 'About',
        component: () => import('@/views/AboutView.vue')
    },
    {
        path: '/compliance/audit',
        name: 'Audit',
        component: () => import('@/views/AuditView.vue')
    },
    {
        path: '/compliance/trade',
        name: 'Trade',
        component: () => import('@/views/TradeView.vue')
    },
    {
        path: '/compliance/training',
        name: 'Training',
        component: () => import('@/views/TrainingView.vue')
    },
    {
        path: '/delegation/:id',
        name: 'Delegation',
        component: () => import('@/views/DelegationView.vue')
    },
    {
        path: '/center/:id',
        name: 'Centers',
        component: () => {
            return import('@/views/CenterView.vue'); // 默认组件
        }
    },
    {
        path: '/center',
        name: 'Center',
        component: () => import('@/views/CenterListView.vue')
    },
    {
        path: '/global',
        name: 'Global',
        component: () => import('@/views/GlobalView.vue')
    },
    {
        path: '/signup/Success',
        name: 'SignSuccess',
        component: () => import('@/views/SignSuccessView.vue')
    },
    {
        path: '/professionSign',
        name: 'ProfessionSign',
        component: () => import('@/views/ProfessionSignView.vue')
    },
    {
        path: '/VolunteerSign',
        name: 'VolunteerSign',
        component: () => import('@/views/VolunteerSignView.vue')
    },
    {
        path: '/lawyerSign',
        name: 'LawyerSign',
        component: () => import('@/views/LawyerView.vue')
    },
    {
        path: '/news',
        name: 'NewsList',
        component: () => import('@/views/NewsListView.vue')
    },
    {
        path: '/news/:id',
        name: 'News',
        component: () => import('@/views/NewsView.vue')
    },
    {
        path: '/upgrade',
        name: 'Upgrade',
        component: () => import('@/views/UpgradeView.vue')
    },
    {
        path: '/notice/:id',
        name: 'Notice',
        component: () => import('@/views/NoticeView.vue')
    },
    {
        path: '/publicity/:id',
        name: 'Publicity',
        component: () => import('@/views/PublicityView.vue')
    },
    {
        path: '/entrustment',
        name: 'Entrustment',
        component: () => import('@/views/EntrustmentView.vue')
    },
    {
        path: '/expert',
        name: 'Expert',
        component: () => import('@/views/ExpertView.vue')
    },
    {
        path: '/legalAid',
        name: 'LegalAid',
        component: () => import('@/views/AidView.vue')
    },
    /*    {
            path: '/legalDocument',
            name: 'LegalDocument',
            component: () => import('@/views/DocumentView.vue')
        },*/
    {
        path: '/legalExpert',
        name: 'LegalExpert',
        component: () => import('@/views/DataBaseView.vue')
    },
    {
        path: '/overseas',
        name: 'OverseasSignUp',
        component: () => import('@/views/OverseasSignUpView.vue')
    },
    {
        path: '/lawyerTeam',
        name: 'LawyerTeam',
        component: () => import('@/views/LawyerTeamView.vue')
    },
    {
        path: '/ai/consulting',
        name: 'AiConsulting',
        component: () => import('@/views/AiView.vue')
    },
    {
        path: '/ai/document',
        name: 'AiDocument',
        component: () => import('@/views/Ai2View.vue')
    },
    {
        path: '/ai/review',
        name: 'AiReview',
        component: () => import('@/views/Ai3View.vue')
    },
    {
        path: '/ai/video',
        name: 'AiVideo',
        component: () => import('@/views/AiVideoView.vue')
    },
    {
        path: '/ai',
        name: 'AiRoute',
        component: () => import('@/views/AiRouteView.vue')
    },
    {
        path: '/consulting',
        name: 'Consulting',
        component: () => import('@/views/ConsultingView.vue')
        /*        meta: {requiresAuth: true} // 需要登录的页面*/
    },
    {
        path: '/exchange',
        name: 'Exchange',
        component: () => import('@/views/ExchangeView.vue')
    },
    {
        path: '/exchange/:id',
        name: 'ExchangeDetail',
        component: () => import('@/views/ExchangeDetailView.vue')
    },
    {
        path: '/worldMap',
        name: 'WorldMap',
        component: () => import('@/views/WorldMapView.vue')
    },
    {
        path: '/mediate',
        name: 'Mediate',
        component: () => import('@/views/MediateView.vue')
    },
    {
        path: '/bussiness',
        name: 'Bussiness',
        component: () => import('@/views/BussinessView.vue')
    },
    {
        path: '/diffcult',
        name: 'Diffcult',
        component: () => import('@/views/DiffcultView.vue')
    },
    {
        path: '/help',
        name: 'Help',
        component: () => import('@/views/HelpView.vue')
    },
    {
        path: '/us',
        name: 'Us',
        component: () => import('@/views/QuestionView.vue')
    },
    {
        path: '/digital/:id',
        name: 'Digitals',
        component: () => {
            return import('@/views/DigitalView.vue'); // 默认组件
        }
    },
    /*    {
            path: '/test',
            name: 'Test',
            component: () => import('@/views/TestView.vue')
        },*/
    {
        path: '/:pathMatch(.*)*', // 匹配所有未定义的路由
        redirect: '/upgrade'
    }
]

const router = createRouter({
        history: createWebHistory(process.env.BASE_URL),
        routes,
    })
;


router.afterEach(async () => {
    await nextTick(); // 等待 DOM 更新
    window.scrollTo({top: 0, behavior: 'auto'});
});

export default router;

